<template>
  <div class="sui-checkbox-toggle">
    <label class="sui-checkbox-toggle__container">
      <input
          :checked="props.modelValue"
          :value="props.value"
          class="sui-checkbox-toggle__control"
          type="checkbox"
          :disabled="props.disabled"
          :name="props.name"
          @change="onChange"
      />
      <div class="sui-checkbox-toggle__switch"></div>
    </label>
    <span
        v-if="props.label"
        class="sui-checkbox-toggle__text"
        v-html="props.label"
    ></span>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  value:{
      type: [String, Number],
      default: ''
  },
  disabled: {
      type: Boolean,
      default: false,
  },
  label: {
      type: String,
      default:''
  },
  name: {
      type: String,
      default: '',
  },
})

const emit = defineEmits(['change', 'update:modelValue'])

function onChange(event: Event): void {
  const checked = (event.target as HTMLInputElement).checked
  emit('update:modelValue', checked)
  emit('change', checked)
}

</script>

<style lang="scss" scoped>
.sui-checkbox-toggle {
  display: flex;
  align-items:center;
  &__container {
    display: inline-block;
    margin: 0;
    position: relative;
    user-select: none;
    border-radius: 12px;
  }
  &__switch {
    display: inline-block;
    height: 24px;
    width: 48px;
    border-radius: 12px;
    position: relative;
    vertical-align: top;
    background: var(--color-text-tertiary);
    border:1px solid var(--stroke-cards);
    transition: .2s;
    &:before {
      content: '';
      display: inline-block;
      width: 16px;
      height: 16px;
      position: absolute;
      top: 3px;
      left: 3px;
      background: var(--color-bg-primary);
      border-radius: 50%;
      transition: .15s;
    }
  }
  &__text {
    color: var(--color-text-primary);
    font-size: 16px;
    line-height: 1;
    margin-left: 8px;
  }
  &__control {
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    z-index: -1;
    opacity: 0;
    &:disabled {
      &+.sui-checkbox-toggle {
        &__switch {
          border-color: var(--stroke-cards);
          background-color: var(--color-button-disabled);
          &:before {
            background: var(--stroke-cards);
          }
        }
      }
      &:checked {
        &+.sui-checkbox-toggle {
          &__switch {
            border-color: var(--stroke-cards);
            background-color: #A0A2A8;
            &:before {
              background: var(--stroke-cards);
            }
          }
        }
      }
    }
    &:checked {
      &+.sui-checkbox-toggle {
        &__switch {
          background-color: var(--color-icon-accent);
          border:1px solid var(--color-icon-accent);
          &:before {
            transform:translateX(24px);
          }
        }
      }
    }
  }
}
</style>